import type { CommunityGroupFormProps } from "@/modules/community-groups/components/community-group-editor/CommunityGroupForm";
import { useTranslation } from "@/translations";

export function useInterestGroupFormTranslations(isEditMode: boolean): CommunityGroupFormProps["translations"] {
  const { t } = useTranslation();

  return {
    title: isEditMode
      ? t("page.interest-group.create-or-edit.edit-mode.title")
      : t("page.interest-group.create-or-edit.create-mode.title"),
    actionFinish: isEditMode ? t("component.wizard.action.edit.finish") : t("component.wizard.action.create.finish"),
    fieldName: "model.interest-group.name",
    fieldNamePlaceholder: t("model.interest-group.name.placeholder"),
    fieldDescription: "model.interest-group.description",
    fieldDescriptionPlaceholder: t("model.interest-group.description.placeholder"),
    fieldIcon: t("model.interest-group.icon-char"),
    fieldIconDescription: t("model.interest-group.icon-char.description"),
    fieldIconPlaceholder: t("model.interest-group.icon-char.placeholder"),
    fieldImage: t("model.interest-group.image"),
    fieldImageDescription: t("model.interest-group.image.description"),
    fieldImagePlaceholder: t("model.interest-group.image.placeholder"),
    fieldAudienceDescription: t("model.constraint.audience"),
    fieldAddressDescription: t("page.interest-group.create-or-edit.constraint.address.description"),
    fieldBuildingDescription: t("page.interest-group.create-or-edit.constraint.building.description"),
    fieldCompanyDescription: t("page.interest-group.create-or-edit.constraint.company.description"),
    fieldFloorDescription: t("page.interest-group.create-or-edit.constraint.floor.description"),
    appPreviewTitle: t("page.interest-group.create-or-edit.app-preview.title"),
    appPreviewOpen: t("page.interest-group.create-or-edit.app-preview.open"),
    canComment: t("model.permission.community.interest-group.can-comment"),
    canCreateAnnouncement: t("model.permission.community.interest-group.can-create-announcement"),
    canCreatePost: t("model.permission.community.interest-group.can-create-post"),
    canListPosts: t("model.permission.community.interest-group.can-list-posts"),
  };
}
